import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  section: {
    width: '100%',
    paddingTop: theme.spacing(1.5),
    marginBottom: theme.spacing(-4),
    paddingBottom: 0,
    display: 'flex',
    flexDirection: 'column',
    maxHeight: theme.spacing(42.875),
    overflow: 'auto',
    paddingRight: theme.spacing(2),
    '&::-webkit-scrollbar-track': {
      borderRadius: theme.spacing(2.25),
      backgroundColor: theme.palette.bgPrimary.main,
    },
    '&::-webkit-scrollbar': {
      width: theme.spacing(1),
      height: theme.spacing(1),
      backgroundColor: theme.palette.bgPrimary.main,
    },
    '&::-webkit-scrollbar-thumb': {
      width: theme.spacing(1),
      borderRadius: theme.spacing(2.25),
      backgroundColor: theme.palette.bgSecondary.main,
    },
  },
  recipientName: {
    color: theme.palette.labraText.tertiary,
    maxWidth: '40%',
  },
  recipientNameWithoutTitle: {
    width: '90%',
  },
  lastRowItem: {
    paddingBottom: `${theme.spacing(4)} !important`,
  },
  recipientTitle: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
  },
  recipientTitleWrapper: {
    display: 'flex',
    width: '95%',
    gap: theme.spacing(1),
    flexWrap: 'wrap',
  },
  recipientTitleName: {
    fontSize: '16px',
    lineHeight: theme.spacing(3),
    width: '40%',
    color: theme.palette.labraText.secondaryDescription,
  },
  rowItem: {
    padding: theme.spacing(1.5, 0),
  },
  rightSection: {
    padding: `${theme.spacing(2, 3)}`,
  },
  editActionLabel: {
    display: 'flex',
    alignItems: 'center',
  },
  disabledEdit: {
    opacity: '39%',
  },
  emptyState: {
    height: theme.spacing(13.4),
    width: theme.spacing(15.5),
    background:
      'linear-gradient(90deg, rgba(253, 194, 216, 0.4) 0%, rgba(252, 166, 94, 0.4) 32.5%, rgba(255, 121, 131, 0.4) 64.5%, rgba(4, 18, 130, 0.4) 100%)',
    '& img': {
      height: '100%',
      width: theme.spacing(15.5),
    },
    borderRadius: theme.spacing(1),
  },
  emptyStateContent: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(3, 4),
    backgroundColor: theme.palette.common.white,
    borderRadius: theme.spacing(1),
    gap: theme.spacing(2.5),
  },
  emptyStateText: {
    color: theme.palette.labraText.primary,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
  },
  emptyRightSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  addBtn: {
    width: theme.spacing(9.625),
    fontSize: '14px !important',
  },
}))
